import { useState } from "react";
import { faqItems } from "@/mocks/content";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>("faq-1");

  return (
    <section id="faq" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <SectionHeading
          eyebrow="常见问题"
          title="关于最新网址与入口的常见疑问"
          desc="这里整理了用户最常问的八个问题，涵盖地址更新、入口选择、防走失与安全注意事项。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {faqItems.map((item) => {
            const open = openId === item.id;
            return (
              <div
                key={item.id}
                className={`rounded-lg border bg-background-50 transition-colors ${
                  open ? "border-primary-300" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenId(open ? null : item.id)}
                  aria-expanded={open}
                  className="w-full flex items-start justify-between gap-3 text-left px-4 md:px-5 py-4 cursor-pointer"
                >
                  <span className="flex items-start gap-2.5">
                    <i className={`ri-question-line mt-0.5 ${open ? "text-primary-600" : "text-foreground-400"}`}></i>
                    <span className="font-medium text-sm md:text-base text-foreground-950 leading-snug">{item.q}</span>
                  </span>
                  <i
                    className={`shrink-0 mt-0.5 transition-transform duration-300 ${
                      open ? "ri-subtract-line text-primary-600 rotate-180" : "ri-add-line text-foreground-400"
                    }`}
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-4 md:px-5 pb-4 pl-10 md:pl-11 text-sm text-foreground-600 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-8 rounded-lg bg-primary-50 border border-primary-200 p-5 md:p-6 flex flex-col md:flex-row items-start md:items-center gap-4 justify-between">
          <div className="flex items-start gap-3">
            <i className="ri-lightbulb-flash-line text-primary-600 text-xl mt-0.5"></i>
            <div>
              <h3 className="font-heading font-semibold text-foreground-950">还有别的疑问？</h3>
              <p className="mt-1 text-sm text-foreground-600 leading-relaxed">
                大多数情况下，把本页收藏起来并记住主线路，就能解决找不到入口的问题。
              </p>
            </div>
          </div>
          <a
            href="#addresses"
            className="inline-flex items-center gap-1.5 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors shrink-0"
          >
            <i className="ri-links-line"></i>返回最新地址
          </a>
        </div>
      </div>
    </section>
  );
}